module.exports = __webpack_public_path__ + "static/media/helpnew.773581dd.svg";